export type ReportingStatus = "billable" | "active";

export type ReportingPlatform = "wialon" | "mapon" | "v5" | "unattributed";

export const platformLabelOf = (p: string): string =>
  p === "unattributed" ? "Sin plataforma" : p.charAt(0).toUpperCase() + p.slice(1);

export interface ReportingParams {
  status: ReportingStatus;
  thresholdSec: number;
  criticalPct: number;
  minUnits: number;
}

export const REPORTING_DEFAULTS: ReportingParams = {
  status: "billable",
  thresholdSec: 86400,
  criticalPct: 50,
  minUnits: 5,
};

export const THRESHOLD_OPTIONS: { label: string; value: number }[] = [
  { label: "24 h", value: 86400 },
  { label: "48 h", value: 172800 },
  { label: "7 días", value: 604800 },
  { label: "30 días", value: 2592000 },
];

export const MIN_UNITS_OPTIONS: { label: string; value: number }[] = [
  { label: "1+", value: 1 },
  { label: "5+", value: 5 },
  { label: "10+", value: 10 },
  { label: "20+", value: 20 },
];

export const CRITICAL_PCT_OPTIONS: { label: string; value: number }[] = [
  { label: "< 25%", value: 25 },
  { label: "< 40%", value: 40 },
  { label: "< 50%", value: 50 },
  { label: "< 60%", value: 60 },
];

export const REPORT_DEFAULT_RECIPIENTS: string[] = [
  "ghernandez@dumaxst.com",
  "lcabrera@dumaxst.com",
  "gcruz@dumaxst.com",
  "pruebas@dumaxst.com",
  "iolozagaste@dumaxst.com",
  "dguzman@dumaxst.com"
];

export const RISK_THRESHOLDS = {
  healthy: 80,
  warning: 60,
  highRisk: 40,
};

export type RiskBucket = "healthy" | "warning" | "highRisk" | "critical";

export function classifyRisk(effectivenessPct: number): RiskBucket {
  if (effectivenessPct >= RISK_THRESHOLDS.healthy) return "healthy";
  if (effectivenessPct >= RISK_THRESHOLDS.warning) return "warning";
  if (effectivenessPct >= RISK_THRESHOLDS.highRisk) return "highRisk";
  return "critical";
}

export const RISK_LABELS: Record<RiskBucket, string> = {
  healthy: "Óptimo",
  warning: "Advertencia",
  highRisk: "Alto riesgo",
  critical: "Crítico",
};

export const RISK_COLORS: Record<RiskBucket, string> = {
  healthy: "#22c55e",
  warning: "#e1d82e",
  highRisk: "#f59e0b",
  critical: "#ef4444",
};

/** Color de barra en comparación de plataforma por efectividad: ≤20 rojo · ≤60 amarillo · >60 verde */
export function getEffectivenessBarColor(pct: number): string {
  if (pct <= 20) return "#ef4444";
  if (pct <= 60) return "#eab308";
  return "#22c55e";
}
